export default function computeColumnWidths(numberOfColumns = 0, columnWidth = 30, defaultColumnWidth = 30, totalTableWidth = 216) {
    let distributedColumnWidth = totalTableWidth / numberOfColumns;
    let columnStyles = {};
    for (let i = 0; i < numberOfColumns; i++) {
        columnStyles[i] = { cellWidth: distributedColumnWidth };
    }
    columnStyles.default = { cellWidth: defaultColumnWidth };

    return columnStyles;
}